import { Grid, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { TConfigCCOTitulosPagar } from '../../../../../../../types/api/financeiro/conta-corrente-consumo-configuracoes'
import { useMemo } from 'react'
import SelectLocaisCobranca from '../../../../../../../components/SelectsSimpleApiQuery/SelectLocaisCobranca'
import MultipleDatePicker from '../../../../../../../components/MultipleDataPicker'
import moment, { Moment } from 'moment'
import SelectTipoDocPagar from '../../../../../../../components/SelectsSimpleApiQuery/SelectTipoDocPagar'
import SelectPlanoContas from '../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas'
import SelectLojaComPesquisa from '../../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa'
export default function CCOGerarTitulosPagarConfig() {

    const { setValue, watch, control } = useFormContext()

    const titulosPagarParams: TConfigCCOTitulosPagar | null = watch('config_geracao_titulo_pagar')

    const valueDiasVencimento = useMemo(() => {
        return titulosPagarParams?.dias_vencimento
    }, [titulosPagarParams?.dias_vencimento])


    return (
        <>
            <Typography mt={1} mb={2}><b>Configuração de geração de títulos a Pagar</b></Typography>
            <Grid container spacing={2}>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_pagar.tipo_documento'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectTipoDocPagar
                                    {...field}
                                    required
                                    label='Tipo documento'
                                    value={field.value}
                                    error={invalid}
                                    errorMessage={error?.message}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_pagar.local_cobranca'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectLocaisCobranca
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_pagar.conta_credora'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectPlanoContas
                                    {...field}
                                    inputLabel="Conta credora"
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChangeValue={(valor) => field.onChange(valor)}
                                    extraParams={{ sistema_xy: "D-PAG" }}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_pagar.loja'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <SelectLojaComPesquisa
                                    {...field}
                                    required
                                    error={invalid}
                                    value={field.value}
                                    onChange={(valor) => field.onChange(valor)}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid size={{xs: 6}}>
                    <Controller
                        name='config_geracao_titulo_pagar.dias_vencimento'
                        control={control}
                        rules={{ required: 'Campo obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => {
                            return (
                                <MultipleDatePicker
                                    required
                                    blockPastDates
                                    label="Dias do vencimento"
                                    value={valueDiasVencimento
                                        ? valueDiasVencimento.map(day =>
                                            moment().set('date', day)
                                        )
                                        : []
                                    }
                                    formatString="DD"
                                    onChange={(data: Moment[] | null) => { setValue('config_geracao_titulo_pagar.dias_vencimento', data?.map(item => Number(item.format('DD')))) }}
                                />
                            )
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}
